import * as React from 'react';

import { CKEditor  } from '@ckeditor/ckeditor5-react';
import  ClassicEditor  from '@ckeditor/ckeditor5-build-classic';

import {
    Col,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
} from 'reactstrap';
import { useForm } from "react-hook-form";
import { useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import SelectLanguage from '../../../shared/components/Inputs/SelectLanguage';
import { useNavigate } from 'react-router-dom';
import useStaticContentQuery from '../../../services/static_contents';
interface IProps {

}

const CreateStaticContents: React.FC<IProps>= () =>  {
    let navigate = useNavigate();
    const onSuccessSubmit = () => {
        toast('Seo texts created', {
            duration: 2000,
            position: 'top-center',
            icon: '👍🏻',
            iconTheme: {
              primary: '#000',
              secondary: '#f2f2f2',
            },
            ariaProps: {
              role: 'status',
              'aria-live': 'polite',
            },
          });
        setTimeout(() => {
            navigate(-1)
        }, 1000);
    }
    const {
        mutate: mutateStaticContentCreate,
    } = useStaticContentQuery.useCreate(onSuccessSubmit);
     
    const  onSubmit = (data:{}) => {
        mutateStaticContentCreate(data)
    };
    const { register, handleSubmit,setValue, formState: { errors } } = useForm();
    const {ref:keyRef,...key} = register('key', { required: true })

    

    useEffect(() => {
        register('value')
    })
      
    return (
        <Card className='mt-3'>
            <Toaster />
            <CardBody>
                <h4 className="header-title">Create StaticContents</h4>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup row>
                        <Label for="key" sm={3}>
                            Key
                        </Label>
                        <Col sm={9}>
                            <Input id="key" type="text"  {...key} innerRef={keyRef} placeholder="Enter key" />
                            {errors.key && <span>This field is required</span>}
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="value" sm={3}>
                            Value
                        </Label>
                        <Col sm={9}>
                        <CKEditor editor={ ClassicEditor } onChange={( event:any, editor:any ) => {
                            const data = editor.getData();
                            setValue('value', data)
                        }
                            } />
                            {errors.value && <span>This field is required</span>} 
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="language_id" sm={3}>
                            Language
                        </Label>
                        <Col sm={9}>
                            <SelectLanguage {...register('language_id')} onChange={(value:any)=>{
                                setValue('language_id',value.value)
                            }}/>
                            {errors.language_id && <span>This field is required</span>}
                        </Col>
                    </FormGroup>

                    <Button color="primary" type="submit">
                        Submit
                    </Button>
                </Form>
                
            </CardBody>
        </Card>
      
    )
} 

export default CreateStaticContents;
